import ProfileList from "../../components/Table/ProfileList";

const AdminProfile = () => <ProfileList />;
export default AdminProfile;
